import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useWishlist } from '../contexts/WishlistContext'

interface WishlistButtonProps {
  productId: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export default function WishlistButton({ productId, size = 'md', className = '' }: WishlistButtonProps) {
  const { user } = useAuth()
  const { isInWishlist, toggleWishlist } = useWishlist()
  const navigate = useNavigate()
  const [isToggling, setIsToggling] = useState(false)

  const isWishlisted = isInWishlist(productId)

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  }

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  }

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (!user) {
      navigate('/login')
      return
    }

    setIsToggling(true)
    await toggleWishlist(productId)
    setIsToggling(false)
  }

  return (
    <button
      onClick={handleClick}
      disabled={isToggling}
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center transition-all ${
        isWishlisted
          ? 'bg-red-50 text-red-500 hover:bg-red-100'
          : 'bg-white/90 text-gray-400 hover:text-red-500 hover:bg-white'
      } ${isToggling ? 'opacity-50' : ''} ${className}`}
      title={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
    >
      {isToggling ? (
        <span className={`${iconSizes[size]} border-2 border-current border-t-transparent rounded-full animate-spin`} style={{ width: size === 'sm' ? '16px' : size === 'md' ? '20px' : '24px', height: size === 'sm' ? '16px' : size === 'md' ? '20px' : '24px' }}></span>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill={isWishlisted ? 'currentColor' : 'none'}
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={iconSizes[size]}
          style={{ width: size === 'sm' ? '16px' : size === 'md' ? '20px' : '24px', height: size === 'sm' ? '16px' : size === 'md' ? '20px' : '24px' }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
          />
        </svg>
      )}
    </button>
  )
}
